import { useInView } from "react-intersection-observer";
import "../Styles/about.css";

export default function About() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  return (
    <div className="about-container" id="about" ref={ref}>
      <div className="about-image"></div>
      <div
        id={inView ? "about-text" : "about-text-before-animation"}
        className={inView ? "animate__animated animate__zoomIn" : ""}
      >
        <h1>Sobre a Premye</h1>
        <span>
          Somos uma empresa especializada em soluções estratégicas de tecnologia
          e financeira de alta complexidade. Nosso time é formado por
          especialistas na área de desenvolvimento, tecnologia e financeira.
          Estamso comprometidos em garantir que os seus projetos ocorram com a
          máxima eficiência, confidencialidade e segurança.
        </span>
      </div>
    </div>
  );
}
